import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { BreadcrumbSchema } from "@/lib/seo";

/** Visible breadcrumb trail + BreadcrumbList schema. items: [{ name, path }] (Home is added). */
export default function Breadcrumbs({ items, className = "" }) {
  const all = [{ name: "Home", path: "/" }, ...items];
  return (
    <>
      <nav aria-label="Breadcrumb" className={`text-sm text-slate-500 ${className}`}>
        <ol className="flex flex-wrap items-center gap-1">
          {all.map((it, i) => {
            const last = i === all.length - 1;
            return (
              <li key={it.path} className="flex items-center gap-1 min-w-0">
                {i > 0 && <ChevronRight className="w-3.5 h-3.5 shrink-0 text-slate-400" aria-hidden />}
                {last ? (
                  <span aria-current="page" className="font-medium text-slate-700 truncate">{it.name}</span>
                ) : (
                  <Link to={it.path} className="hover:text-[#25D366] transition-colors">{it.name}</Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      <BreadcrumbSchema items={items} />
    </>
  );
}
